import { AppBanner, useAppBanner } from '@/components/AppBanner';
import useAppAnalytics from '@/hooks/useAppAnalytics';
import { useAnalytics } from '@/services/analytics';
import { useHubspot } from '@/services/hubspot';
import useZendeskWidget from '@/services/zendesk/useZendeskWidget';
import { useUserSettings } from '@/state/user-settings/UserSettingsProvider';
import React, { useEffect } from 'react';

interface Props {
    children: React.ReactNode;
}

export const Layouts = ({ children }: Props) => {
    useAppAnalytics();
    useHubspot();
    useZendeskWidget();

    const mixpanel = useAnalytics();
    const { isOpen } = useAppBanner();
    const { userSettings, updateUserSettings } = useUserSettings();
    const isAgentsEnabledFlag = true;

    const isExistingUserOnBoarding =
        userSettings?.features?.onBoarding?.answers?.state?.onboard_class &&
        !userSettings?.features?.onBoarding?.answers?.state?.onboard_new_class;

    useEffect(() => {
        mixpanel?.enrich({ agents_enabled: isAgentsEnabledFlag });
    }, [mixpanel, isAgentsEnabledFlag]);

    useEffect(() => {
        if (isExistingUserOnBoarding) {
            updateUserSettings({
                features: {
                    onBoarding: {
                        answers: {
                            step: 0,
                        },
                        finished: false,
                    },
                },
            });
        }
    }, [isExistingUserOnBoarding]);

    return (
        <>
            {isOpen && <AppBanner />}
            {children}
        </>
    );
};
